import http from '@/plugin/axios';

export default {
  /**
   * 保存or更新联系人群组
   */
  saveOrUpdateContactGroup: (data: any): Promise<any> => {
    return http.post('/activity/contact/saveOrUpdateContactGroup', data);
  },
  /**
   * 联系人群组名称(只有名称和id)
   */
  getContactGroupNameList: (data: any): Promise<any> => {
    return http.post('/activity/contact/getContactGroupNameList', data);
  },
  /**
   * 全部联系人个数和群组数据(查出个数)
   */
  getContactGroupTotal: (data: any): Promise<any> => {
    return http.post('/activity/contact/getContactGroupTotal', data);
  },
  /**
   * 删除联系人群组
   */
  delContactGroup: (data: any): Promise<any> => {
    return http.post('/activity/contact/delContactGroup', data);
  },
  /**
   * 保存or更新联系人
   */
  saveOrUpdateContact: (data: any): Promise<any> => {
    return http.post('/activity/contact/saveOrUpdateContact', data);
  },
  /**
   * 用户联系人List
   */
  getContactList: (data: any): Promise<any> => {
    return http.post('/activity/contact/getContactList', data);
  },
  /**
   * 自定义显示全部列字段List
   */
  getFieldNameList: (data: any): Promise<any> => {
    return http.post('/activity/contact/getFieldNameList', data);
  },
  /**
   * 联系人显示字段
   */
  getShowFieldList: (data: any): Promise<any> => {
    return http.post('/activity/contact/getShowFieldList', data);
  },
  /**
   * 保存自定义字段
   */
  saveCustomField: (data: any): Promise<any> => {
    return http.post('/activity/contact/saveCustomField', data);
  },
  /**
   * 自定义字段list
   */
  getCustomFieldList: (data: any): Promise<any> => {
    return http.post('/activity/contact/getCustomFieldList', data);
  },
  /**
   * 保存or更新or删除显示字段
   */
  saveOrUpdateFieldList: (data: any): Promise<any> => {
    return http.post('/activity/contact/saveOrUpdateFieldList', data);
  },
  /**
   * 重置显示字段
   */
  getResetField: (data: any): Promise<any> => {
    return http.post('/activity/contact/getResetField', data);
  },
  /**
   *  默认字段 是否需要重置字段
   */
  getDefaultField: (data: any): Promise<any> => {
    return http.post('/activity/contact/getDefault', data);
  },
  /**
   *  导入联系人（Excel（xlsx格式））
   */
  getImportContact: (data: any): Promise<any> => {
    return http.post('/activity/contact/getImportContact', data);
  },
  /**
   *  删除联系人
   */
  delContact: (data: any): Promise<any> => {
    return http.post('/activity/contact/delContact', data);
  },
  /**
   *  保存系统短信回执
   */
  saveSysMessageReceipt: (data: any): Promise<any> => {
    // return http.post("/activity/message/receipt/saveSysMessageReceipt", data);
    return http.post('/activity/contact/saveContactReceipt', data);
  },
  /**
   *  系统的短信回执list
   */
  getSysReceiptList: (data: any): Promise<any> => {
    return http.post('/activity/contact/getUserContactReceipt', data);
  },
  /**
   *  手机短信详情
   */
  getSysSmsDetail: (data: any): Promise<any> => {
    return http.post('/activity/contact/getContactSmsDetail', data);
  },
  /**
   *  重新发送短信
   */
  getAgainMessageSms: (data: any): Promise<any> => {
    return http.post('/activity/message/contact/getAgainContactSms', data);
  },
  /**
   *  添加手机详情
   */
  addSmsDetail: (data: any): Promise<any> => {
    return http.post('/activity/message/contact/addSmsDetail', data);
  },
  /**
   *  删除手机短息详情
   */
  delSmsDetail: (data: any): Promise<any> => {
    return http.post('/activity/message/contact/delSmsDetail', data);
  },
  /**
   *  重新单个手机短息详情
   */
  getAgainSms: (data: any): Promise<any> => {
    return http.post('/activity/message/contact/getContactAgainSms', data);
  },
  /**
   *  重添加联系人到群组
   */
  addContactByGroup: (data: any): Promise<any> => {
    return http.post('/activity/contact/addContactByGroup', data);
  },
  /**
   *  签名名称list
   */
  getSmsSignName: (data: any): Promise<any> => {
    return http.post('/activity/sms/sign/getSmsSignName', data);
  },
  /**
   *  保存短信签名
   */
  saveOrUpdateSmsSign: (data: any): Promise<any> => {
    return http.post('/activity/sms/sign/saveOrUpdateSmsSign', data);
  },
  /**
   *  状态的签名
   */
  getSmsSignStatus: (data: any): Promise<any> => {
    return http.post('/activity/sms/sign/getSmsSignStatus', data);
  },
  /**
   *  用户的联系人回执状态
   */
  getContactReceiptStatus: (data: any): Promise<any> => {
    return http.post('/activity/contact/getContactReceiptStatus', data);
  },
};
